import React, { useState } from "react";
import styled from "styled-components";
import { setToken } from "../../helper";
import {
  Form,
  Input,
  Button,
  Col,
  Result,
  message,
  Row
} from "antd";
import { LockOutlined } from "@ant-design/icons";
import Api from "api";
import { ThemeConfig } from "theme";
import { passwordValidatorAnt } from "helper/passwordValidatorAnt";

const LoginWrapper = styled.div`
  width: 100vw;
  margin-top: 70px;
  min-height: calc(100vh - 100px);
  // height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 50px 20px;
  h4 {
    color: #494848;
    text-align: center;
    text-transform: uppercase;
    font-size: 23px;
    line-height: 30px;
    padding: 0 0 10px;
    letter-spacing: 0.5px;
    margin: 0;
    font-family: inherit;
    font-weight: 500;
  }
  .checkboxWrapper {
    text-align: center;
    // margin: 10px;
  }
  .mtb10 {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .greyLink {
    text-decoration: none;
    color: #8a8787;
    font-weight: 400;
    font-size: 14px;
  }
  .ant-form-item {
    // margin-bottom: 0px;
  }
  .submit {
    padding: 0 30px !important;
    color: #fff !important;
    background: #08243c !important;
    border: none !important;
    line-height: 35px !important;
    height: 35px !important;
    font-size: 16px !important;
    border-radius: 4px !important;
    text-transform: uppercase !important;
    cursor: pointer !important;
    width: auto !important;
    margin: 16px 0;
  }
`;

const FormWrapper = styled.div`
  width: 100%;
`;



interface Props {
  resetToken: any;
}

const ResetPasswordForm = (props: Props) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState<boolean>();
  const [result, setResult] = useState<string>();
  const handleResetPassword = async (values) => {
    setLoading(true);
    try {
      const { data } = await Api.post("/auth/reset_password", {
        password: values.password,
        token: props.resetToken,
      });
      setLoading(false);
      if (data && data.token) {
        await setToken(data.token.split("JWT ")[1]);
        setResult("Password reset successfully");
      }
    } catch (e: any) {
      console.log(e);
      setLoading(false);
      const errorMsg =
        (e &&
          e.response &&
          e.response.data &&
          e.response.data.messages &&
          e.response.data.messages[0]) ||
        "Failed to reset password";
      console.log(errorMsg);
      message.error({ content: errorMsg, duration: 3 });
    }
  };
  const layout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };
  if (result && result.length) {
    return (
      <LoginWrapper>
        <Result
          status="success"
          title="Signup Success!"
          subTitle={result}
          extra={[
            <Button type="primary" key="console">
              <a href="/">Ok</a>
            </Button>,
          ]}
        />
      </LoginWrapper>
    );
  }
  return (
    <LoginWrapper>
      <FormWrapper>
        <Col lg={{ span: 8, offset: 8 }}>
          <h4 className="mb-3" style={{ color: "#494848" }}>
            CHANGE YOUR PASSWORD
          </h4>
          <Form
            {...layout}
            form={form}
            onFinish={handleResetPassword}
            name="resetPassword"
            layout="vertical"
            autoComplete="off"
          >
            <Row>
              <Col span={24}>
                <Form.Item
                  label="6 characters minimum"
                  name="password"
                  labelAlign="left"
                  rules={[
                    { required: true, message: "Enter your password" },
                    passwordValidatorAnt
                  ]}
                >
                  <Input.Password
                    prefix={
                      <LockOutlined style={{ color: "rgba(0,0,0,.25)" }} />
                    }
                    placeholder="New Password"
                    // onPressEnter={login}
                    // onChange={(e) =>
                    //   setPassword(e.target.value)
                    // }
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  // label="Confirm Password"
                  name="confirmPassword"
                  dependencies={["password"]}
                  labelAlign="left"
                  rules={[
                    {
                      required: true,
                      message: "Please confirm your password!",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error("Passwords should match!")
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password
                    prefix={
                      <LockOutlined style={{ color: "rgba(0,0,0,.25)" }} />
                    }
                    placeholder="Confirm Password"
                  />
                </Form.Item>
              </Col>
            </Row>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                type="primary"
                htmlType="submit"
                className="submit"
                // onClick={login}
                loading={loading}
              >
                Change My Password
              </Button>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                color: ThemeConfig.colors.grey,
              }}
            >
              <a className="greyLink" href="/login">
                Login
              </a>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                color: ThemeConfig.colors.grey,
              }}
            >
              <a className="greyLink" href="/signup">
                Signup
              </a>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                color: ThemeConfig.colors.grey,
              }}
            >
              <a className="greyLink" href="/resend_confirmation">
                Didn't receive confirmation instructions?
              </a>
            </div>
          </Form>
        </Col>
      </FormWrapper>
    </LoginWrapper>
  );
};

export default ResetPasswordForm;
